define('jquery-ex',["jquery"], function (_jquery) {
  "use strict";

  _jquery = _interopRequireDefault(_jquery);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  _jquery.default.fn.trigger = function (event, args) {
    var type = typeof event === 'string' ? event : event.type;
    return this.each(function () {
      if ('dispatchEvent' in this) {
        var _event$bubbles, _event$cancelable;
        event = new CustomEvent(type, {
          bubbles: (_event$bubbles = event.bubbles) !== null && _event$bubbles !== void 0 ? _event$bubbles : true,
          cancelable: (_event$cancelable = event.cancelable) !== null && _event$cancelable !== void 0 ? _event$cancelable : false,
          detail: args
        });
        this.dispatchEvent(event);
      } else {
        (0, _jquery.default)(this).triggerHandler(event, args);
      }
    });
  };
  _jquery.default.fn.show = function () {
    return this.each(function () {
      this.hidden = false;
    });
  };
  _jquery.default.fn.hide = function () {
    return this.each(function () {
      this.hidden = true;
    });
  };
  _jquery.default.fn.toggle = function (state) {
    if (typeof state === 'boolean') {
      return this.each(function () {
        this.hidden = !state;
      });
    } else {
      return this.each(function () {
        this.hidden = !this.hidden;
      });
    }
  };
});//# sourceMappingURL=jquery-ex.js.map
;
